import SparkMD5 from 'spark-md5'
function getMD5(file,callback){
    // var fileReader = new FileReader();
    // var dataFile = file;
    // const _this = this
    var spark = new SparkMD5(); //创建md5对象（基于SparkMD5）
    // fileReader.readAsBinaryString(dataFile);

    //文件读取完毕之后的处理
    // fileReader.onload = function(e) {
        spark.appendBinary(file);
        var md5 = spark.end()
        callback(md5)
    // };

}

export default getMD5